import { render, staticRenderFns } from "./ModalComponentItem.vue?vue&type=template&id=aab226f8&scoped=true"
import script from "./ModalComponentItem.vue?vue&type=script&lang=js"
export * from "./ModalComponentItem.vue?vue&type=script&lang=js"
import style0 from "./ModalComponentItem.vue?vue&type=style&index=0&id=aab226f8&prod&scoped=true&lang=scss"
import style1 from "./ModalComponentItem.vue?vue&type=style&index=1&id=aab226f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab226f8",
  null
  
)

export default component.exports